import { useState } from "react";
import BulkComplexTableEditorModal from "./BulkComplexTableEditorModal";

export default function BulkComplexTableEditorAction({ items, excludedSipCount = 0, sourceSection = "admin", onApplied, buttonStyle, buttonClassName }) {
  const [isOpen, setIsOpen] = useState(false);
  return <><button type="button" className={buttonClassName} style={buttonStyle} onClick={() => setIsOpen(true)}>Редактировать таблицу ЖК</button><BulkComplexTableEditorModal isOpen={isOpen} items={items} excludedSipCount={excludedSipCount} sourceSection={sourceSection} onClose={() => setIsOpen(false)} onApplied={onApplied} /></>;
}
